import { Context, Plugin } from '@nuxt/types'
import { serialize } from '@shared/jsona'
import { AxiosResponse } from 'axios'
import urlParser from 'uri-template'
import resources from './resources'
import Jsona from '~/lib/jsona'
import { API } from '~/types/api'

type TJsonApiBody = ReturnType<typeof serialize>

export interface AxiosResponseExtended<T = any, D = any, R extends TJsonApiBody = TJsonApiBody> extends AxiosResponse<T, D> {
  rawRes?: R
}

const apiPlugin: Plugin = (context: Context, inject) => {
  context.$axios.defaults.xsrfHeaderName = 'X-CSRF-TOKEN'
  context.$axios.defaults.xsrfCookieName = 'XSRF-TOKEN'

  // add interceptor to format json api responses
  // @ts-ignore
  context.$axios.interceptors.response.use(function(res: AxiosResponseExtended) {
    if (res.headers['content-type'] === 'application/vnd.api+json') {
      res.rawRes = res.data
      res.data = { ...res.data, data: Jsona.deserialize(res.data) }
    }
    return res
  })

  const api = Object.keys(resources).reduce((acc, resName) => {
    const actions = resources[resName][2]

    acc[resName] = Object.keys(actions).reduce((acc, actionName) => {
      const { method, url } = actions[actionName]
      const tpl = urlParser.parse(url)

      acc[actionName] = (...args) => {
        const options = {
          method
        } as Axios.AxiosRequestConfig

        if (!args.length) {
          options.url = url
          // @ts-ignore
          return context.$axios(options)
        }

        if (['POST', 'PUT', 'PATCH'].includes(method.toUpperCase())) {
          if (args.length >= 2 && args[1]) {
            options.url = args[0] ? tpl.expand(args[0]) : url
            options.data = args[1]
          } else {
            options.url = url
            options.data = args[0]
          }
        } else if (args[0]) { options.url = tpl.expand(args[0]) }
        // @ts-ignore
        return context.$axios(options)
      }

      return acc
    }, {} as API.ServiceAction)

    return acc
  }, {} as { [key: string]: API.ServiceAction })

  context.$api = api

  inject('api', api)
}

export default apiPlugin
